export const getRequestOptions = {
    headers: { 'Content-Type': 'application/json' },
    method: "GET",
    mode: "cors"
};
